import { DEFAULT_METADATA } from 'store/useBusinessToolStore';

import { IBusinessPlanEntity } from 'interfaces/businessPlan';

export const parseMetadata = (metadata: string): IBusinessPlanEntity['metadata'] => {
  const parsedMetadata = JSON.parse(metadata) as IBusinessPlanEntity['metadata'];

  return {
    isFirstTryToSetBusinessToolTitle: parsedMetadata.isFirstTryToSetBusinessToolTitle,
    pdfDocShortLink: parsedMetadata.pdfDocShortLink,
    pdfShareLink: parsedMetadata.pdfShareLink,
    pdfCreatedAt: parsedMetadata.pdfCreatedAt,
    onePageTemplateStyle: parsedMetadata.onePageTemplateStyle,
    documentColorType: parsedMetadata.documentColorType,
    documentStyleType: parsedMetadata.documentStyleType,
    isShownAIGenerateWholeDocument: parsedMetadata.isShownAIGenerateWholeDocument,
    isHiddenFillOutCard: parsedMetadata.isHiddenFillOutCard,
    isGeneratedWholeDocument: parsedMetadata.isGeneratedWholeDocument,
    aiGeneratedSections: parsedMetadata.aiGeneratedSections,
    aiGeneratedFields: parsedMetadata.aiGeneratedFields,
    updateOnlinePDFCount: parsedMetadata.updateOnlinePDFCount,
    downloadDocumentCount: parsedMetadata.downloadDocumentCount,
  };
};

export const getValidatedMetadata = (metadata: IBusinessPlanEntity['metadata']): IBusinessPlanEntity['metadata'] => {
  return {
    isFirstTryToSetBusinessToolTitle:
      metadata.isFirstTryToSetBusinessToolTitle ?? DEFAULT_METADATA.isFirstTryToSetBusinessToolTitle,
    pdfDocShortLink: metadata.pdfDocShortLink ?? DEFAULT_METADATA.pdfDocShortLink,
    pdfShareLink: metadata.pdfShareLink ?? DEFAULT_METADATA.pdfShareLink,
    pdfCreatedAt: metadata.pdfCreatedAt ?? DEFAULT_METADATA.pdfCreatedAt,
    onePageTemplateStyle: metadata.onePageTemplateStyle ?? DEFAULT_METADATA.onePageTemplateStyle,
    documentColorType: metadata.documentColorType ?? DEFAULT_METADATA.documentColorType,
    documentStyleType: metadata.documentStyleType ?? DEFAULT_METADATA.documentStyleType,
    isShownAIGenerateWholeDocument:
      metadata.isShownAIGenerateWholeDocument ?? DEFAULT_METADATA.isShownAIGenerateWholeDocument,
    isHiddenFillOutCard: metadata.isHiddenFillOutCard ?? DEFAULT_METADATA.isHiddenFillOutCard,
    isGeneratedWholeDocument: metadata.isGeneratedWholeDocument ?? DEFAULT_METADATA.isGeneratedWholeDocument,
    aiGeneratedSections: metadata.aiGeneratedSections ?? DEFAULT_METADATA.aiGeneratedSections,
    aiGeneratedFields: metadata.aiGeneratedFields ?? DEFAULT_METADATA.aiGeneratedFields,
    updateOnlinePDFCount: metadata.updateOnlinePDFCount ?? DEFAULT_METADATA.updateOnlinePDFCount,
    downloadDocumentCount: metadata.downloadDocumentCount ?? DEFAULT_METADATA.downloadDocumentCount,
  };
};
